import { render, staticRenderFns } from "./roleCofing.vue?vue&type=template&id=452055fb"
import script from "./roleCofing.vue?vue&type=script&lang=js"
export * from "./roleCofing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452055fb')) {
      api.createRecord('452055fb', component.options)
    } else {
      api.reload('452055fb', component.options)
    }
    module.hot.accept("./roleCofing.vue?vue&type=template&id=452055fb", function () {
      api.rerender('452055fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/roleManage/roleCofing.vue"
export default component.exports